import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import TransactionItemComponent from '@/components/transaction/TransactionItemComponent.vue';
import router from '@/router';
export default defineComponent({
    name: 'AllTransactionsView',
    components: {
        TransactHeader,
        TransactionItemComponent,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { userTransactions } = storeToRefs(transactionsStore);
        const goBack = () => {
            router.push('/');
        };
        return {
            userTransactions,
            goBack,
        };
    },
});
